import { Typography } from '@mui/material'
import React, { ComponentPropsWithoutRef } from 'react'

export function FieldError({ children }: ComponentPropsWithoutRef<'div'>) {
  return (
    <Typography variant="caption" color="error" className='input-error'>
      {children}
    </Typography>
  )
}

FieldError.defaultProps = {
  required: false,
}
